import Model from './integration_model';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';
import _ from '../../utils/underscore';
import Strings from '../../utils/strings';
import * as INTEGRATION from './integration_const';
import IntegrationB2C from './vendors/b2c/integration_b2c';
import Device from '../../utils/device/device';
import Store from '../../utils/store';
import BaseService from '../../base/base_service';

class IntegrationService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'IntegrationService';


    /**
     * @property
     * @type {object|null}
     * @private
     */
    _model = null;


    /**
     * Integration map factory.
     *
     * @type {Object}
     * @private
     */
    _integrationMapFactory = Object.create(null);


    /**
     * Selected vendor.
     *
     * @type {null}
     * @private
     */
    _selectedVendor = null;


    /**
     * Token unique data to send to marketing b2c b2x b2zubi etc..
     *
     * @type {Object}
     * @private
     */
    _providerData = null;


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);

        this._model = Model.create(params);
        this._subscribe();
        this._initializeIntegrationMap();
    }

    getLinkProxyExecution() {
        return this._model.getProxyLink();
    }

    getNavbarContainerElementSelector() {
        return this._model.getNavbarContainerElementSelector();
    }

    getNavbarRegulationElementSelector() {
        return this._model.getNavbarRegulationElementSelector();
    }


    /**
     *
     * @returns {IntegrationService}
     * @private
     */
    _initializeIntegrationMap() {
        this._integrationMapFactory[INTEGRATION.B2C] = IntegrationB2C;

        return this;
    }


    /**
     * Get vendor action
     *
     * @param action
     * @returns {*}
     * @private
     */
    _vendorAction(action) {
        let vendor = this._integrationMapFactory[this.getRole()] || null;

        if (!_.isNull(this._selectedVendor)) {
            if (!_.isFunction(this._selectedVendor[action])) {
                this.logger.error('There is no action ' + action + ' for vendor => ', vendor);
                return;
            }

            return this._selectedVendor[action];
        }

        if (_.isNull(vendor)) {
            this.logger.error('Could not find vendor instance for role => ', this.getRole());
            return;
        }

        this._selectedVendor = vendor.create({});

        if (!_.isFunction(this._selectedVendor[action])) {
            this.logger.error('There is no action ' + action + ' for vendor => ', vendor);
            return;
        }

        return this._selectedVendor[action].bind(this._selectedVendor);
    }


    /**
     * Check whether the integration has available marketing data.
     *
     * @returns {boolean}
     */
    isMarketingDataExist() {
        return !_.isNull(this.getRecentMarketData());
    }


    /**
     * Get application consumer role.
     *
     * @returns {*}
     */
    getRole() {
        return this._model.getRole();
    }


    /**
     * Get about help link.
     *
     * @returns {*}
     */
    getAboutHelpLink() {
        return this._model.getAboutHelpLink();
    }


    /**
     * Get MyAccountToLobbyUrlLink link.
     *
     * @returns {string}
     */
    getLobbyUrlLink() {
        return this._model.getLobbyUrlLink();
    }


    /**
     * Filter the list with games are available in the site
     * @param gameList
     */
    // getAvailableGameList(gameList) {
    //     if (!_.isArray(gameList)) {
    //         return [];
    //     }
    //     let availableGames = this._model.getGamesList();
    //     return gameList.filter((game) => {
    //         return availableGames.find((availableGame) => {
    //             return availableGame === game
    //         });
    //     });
    // }

    /**
     * return regulation data element only
     * @returns {*}
     */
    getHeaderRegulationDataElement() {
        return this._model.getHeaderRegulationDataElement();
    }


    /**
     * Middleware to check whether the mapper is promise type if not return reject!
     *
     * @param gameTypeList
     * @returns {*}
     */
    gameTypeMapperIsPromiseMiddleWare(gameTypeList) {

        let gameTypeMapperRef = this._model.getGameTypeMapper();

        if (!_.isFunction(gameTypeMapperRef)) {
            return new Promise((resolve, reject) => {
                reject({error: 'Host user not override SDK integration gameTypeMapper function.'});
            });
        }

        let gameTypeMapperRefPromise = gameTypeMapperRef(gameTypeList);

        if (_.isUndefined(gameTypeMapperRefPromise) || _.isNull(gameTypeMapperRefPromise)) {
           this.logger.debug('Invalid result from mapper we expecting for promise => ', gameTypeMapperRefPromise);
            return new Promise((resolve, reject) => {
                reject({error: 'Host user not must set promise type function SDK integration gameTypeMapper function.'});
            });
        }

        if (!_.isFunction(gameTypeMapperRefPromise.then)) {
            this.logger.error('Must return promise type function!');
            return new Promise((resolve, reject) => {
                reject({error: 'Host user not must set promise type function SDK integration gameTypeMapper function.'});
            });
        }

        return gameTypeMapperRefPromise;
    }



    /**
     * Get game addional data from host side by game type list.
     *
     * @param gameTypeList
     * @returns {*}
     */
    getGameTypeMapper(gameTypeList) {
        return this.gameTypeMapperIsPromiseMiddleWare(gameTypeList);
    }


    getAllGameTypes() {
        return this.getGameTypeMapper()
            .then(gamesMap => {
                return Object.keys(gamesMap).map((key) => Number(key));
            });
    }

    filterAllowedToPlayRealGames(gameTypes) {
        return this.serviceFactory.gamesInformationService().getGamesInfo(gameTypes)
            .then(gamesInfo => {
                let result = [];
                gameTypes.forEach(gt => {
                    let gameInfo = gamesInfo[gt];
                    if(gameInfo && gameInfo.restriction.isGameAllowedToPlayReal()) {
                        result.push(gt);
                    }
                });

                return result;
            });
    }

    filterInLayoutGames(gameTypesToFilter) {
        return this.getGameTypeMapper()
            .then(gamesMap => gameTypesToFilter.filter(gt => gamesMap[gt]));
    }

    /**
     * Get recent market data according to marketing flow key.
     *
     * @returns {*}
     */
    getRecentMarketData() {
        let marketData = this._model.getRecentMarketData() ,
            marketingFlowType = this._model.getMarketingFlowType();

        if(_.isNull(marketData) || _.isUndefined(marketData[marketingFlowType]))
            return marketData;

        return marketData[marketingFlowType];
    }


    /**
     * Get MDP message mapper
     *
     * @returns {{}|*}
     */
    getMDPImageMapper() {
        return this._model.getMDPImageMapper();
    }


    /**
     * Subscribe application events.
     *
     * @private
     */
    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.INCOMING_MARKETING_DATA, this._updateMarketingData);
        this.onSystemEvent(SYSTEM_EVENTS.INCOMING_MARKETING_FLOW, this._updateMarketingFlowType);
    }


    /**
     * Update recent marketing data;
     * @param flowType - const "MARKETING_FLOWS" within integration_const.js
     * @private
     */
    _updateMarketingFlowType(flowType) {
        this._model._updateMarketingFlowType(flowType);
    }



    /**
     * Update recent marketing data;
     * @param marketData
     * @private
     */
    _updateMarketingData(marketData) {
        this._model._updateMarketData(marketData);
    }

    /**
     * Request async http request to the olympus (b2c, b2x etc..).
     *
     * @param options
     * @returns {Promise.<T>|*|Promise}
     */
    requestToTheOlympus(options) {
        let stringUtil = new Strings(options.url);
        let shouldReplaceOrigin = stringUtil.startsWith('http://') || stringUtil.startsWith('https://');

        if (!shouldReplaceOrigin) {
            //If we got valid cms source we will use it and not window.location - to support  localhost (embedded Hybrid )
            let cmsSource = this.getCmsSourceIfValid();
            if (cmsSource) {
                options.url = cmsSource + options.url;
            } else {
                options.url = window.location.protocol + '//' + window.location.hostname + options.url;
            }

            return this.serviceFactory.http2Service().post(options.url, options.params)
                .then(() => {
                    this.logger.debug('Success response => ', options.role);
                })
                .catch((responseError) => {
                    this.logger.error('Failed response from => ', 'Role: ', options.role, 'Url: ', options.url, 'Params: ', options.params, 'responseError: ', responseError);
                });
        }

    }

    isMiniCip() {
        return this._model.getIsMiniCip();
    }

    isMiniCis() {
        return this._model.getIsMiniCis();
    }

    isMiniOrbit() {
        return this.isMiniCip() || this.isMiniCis();
    }


/**
     * Bake params with a proper form and default data.
     *
     * @param dataObj
     * @param property
     * @returns {{}}
     */
    bakeParams(dataObj, property) {
        if (!dataObj) {
            this.logger.error('Provider data obj is not valid!');
            return {};
        }

        if (!dataObj[property]) {
            this.logger.error('Provider data obj data ' + property + ' is invalid.');
            return {};
        }

        return dataObj[property] || {};
    }


    /**
     * Get provider data from token.
     *
     * @returns {{}}
     */
    getProviderTokenData() {
        let oauth = this.serviceFactory.oAuth2Service();

        if (this._providerData) {
            this.logger.debug('Provider data from token exist so we returned it => ', this._providerData);
            return this._providerData;
        }

        let role = this._model.getRole();

        this.logger.debug('Provider data from token not exist so we extract from token by role => ', role);

        let providerData = oauth.extractTokenProperty(role);

        this.logger.debug('Extracted provider data from token => ', providerData);

        if ('-1' === providerData || _.isNull(providerData)) {
            this.logger.debug('Not returned from server unique key for the role => ', role);
            return {};
        }

        this._providerData = _.safeJSON(oauth.extractTokenProperty(role), {});

        this.logger.debug('Parsed provider data to json object => ', this._providerData);

        return this._providerData;
    }

    /**
     * Gets the RICH page URL
     * @returns {*}
     */
    getRichPageUrl(campaignId) {
        return this._model.getRichPageUrl(campaignId);
    }

    getMarketingData() {
        const marketingData = {};
        let tempMarketData;
        if (this.isMarketingDataExist()) {
            tempMarketData = this.getRecentMarketData();
            // Use it when there are complex objects in marketData
            Object.keys(tempMarketData).forEach((key) => {
                if (_.isString(tempMarketData[key])) {
                    marketingData[key] = tempMarketData[key];
                } else {
                    marketingData[key] = JSON.stringify(tempMarketData[key]);
                }
            });
        }

        return marketingData;
    }

    executeMarketingDataFunction(marketingDataFunctionCall) {
        try {
            let parsedFunction = _.parseStringFunction(marketingDataFunctionCall);
            let marketingFunctionRef = window[parsedFunction.functionName];

            this.logger.debug('Register (or cashier) clicked, trying to call global get marketing data => ', marketingDataFunctionCall);

            if (_.isFunction(marketingFunctionRef)) {
                Event.fire(SYSTEM_EVENTS.INCOMING_MARKETING_DATA, marketingFunctionRef.apply(marketingFunctionRef, [parsedFunction.functionStringParams]));
            }

        } catch (ex) {
            this.logger.error(`Could not parse market data function ${marketingDataFunctionCall} => `, ex);
        }
    }


    openInNewWindowHook() {
        const hook = this._model.getOpenInNewWindowHook();
        return hook && hook();
    }

    /**
     * @description Return the cms source if it valid url
     * @return {boolean | *}
     */
    getCmsSourceIfValid() {
        const cmsSource = this._model.getCMSSource();
        if(_.isString(cmsSource) && (cmsSource.startsWith('http://') || cmsSource.startsWith('https://'))) {
            return cmsSource
        }
        return false
    }

    _addRunTimeSegments(message) {
        this._addAODSegments(message);
        this._addB2CSegment(message);
    }

    _addAODSegments(message) {
        if (Device.hybrid.isEmbedded) {
            message.cookie_cstatus = Store.getCookie("cstatus");
            message.cookie_tstatus = Store.getCookie("tstatus");
        }
    }

    _addB2CSegment(message) {
        const b2cFeatureName = "B2CABTest";
        let b2cSegments;
        const isAuth = this.serviceFactory.oAuth2Service().isAuthorized();
        if (isAuth) {
            b2cSegments = this.serviceFactory.abTestingService().getAbTestingDataForFeature(b2cFeatureName);
        } else {
            b2cSegments = this.serviceFactory.abTestingService().getAnonymousPlayerAbTestingDataForFeature(b2cFeatureName, true);
        }

        if (b2cSegments && b2cSegments.Properties["group"]) {
            message.B2CABTest = b2cSegments.Properties["group"];
        } else {
            this.logger.warn(`AbTestingFeature ${b2cFeatureName} not found! isAuth: ${isAuth}`);
        }
    }

    /**
     * @description Extract the user token data + signature for both stats(authorized/anonymous)
     */
    getUserSegments() {
        let messageKey, signatureKey;
        let providerDataObj = this.getProviderTokenData() || {};
        let sessionParams = {};

        //If we got empty object so we will send default params
        if(Object.keys(providerDataObj).length ===  0){
            let message = {
                BrandID: this.serviceFactory.skinService().getBrandID(),
                SubBrandID: this.serviceFactory.skinService().getSubBrandID(),
                SystemId: this.serviceFactory.skinService().getPlatformSystemID() || '75',
                lang: this.serviceFactory.languageService().getISO2(),
                IsEmbeddedHybrid : Device.hybrid.isEmbedded,
                IsHybrid : Device.hybrid.isHybrid,
                ProductPackage: this.serviceFactory.skinService().getProductPackageID(),
            }

            const lastSessionData = this.serviceFactory.oAuth2Service().getLastSessionData();
            if(lastSessionData) {
                message.RegulationStatusId = lastSessionData.message?.RegulationStatusId;
                message.IsRisky = lastSessionData.message?.IsRisky;
            }

            this._addRunTimeSegments(message);

            sessionParams.message = JSON.stringify(message);
            return sessionParams;
        }

        if (this.serviceFactory.oAuth2Service().isAuthorized()) {
            messageKey = 'sessionParamsMsg';
            signatureKey = 'sessionParamsSignature';
        }else{
            messageKey = 'logoutObjMsg';
            signatureKey = 'logoutObjSignature';
        }

        //normally we don't write data on the fly there, providerDataObj is coming filled in with all the data from backend side
        //but here we need to access cookies for current domain - this is suitable for frontend side
        this._addRunTimeSegments(providerDataObj[messageKey]);

        sessionParams.message = JSON.stringify(this.bakeParams(providerDataObj, messageKey));
        sessionParams.signature = this.bakeParams(providerDataObj, signatureKey);

        return sessionParams;
    }
}
export default IntegrationService;